import React, { useEffect } from 'react';

import SimpleHeader from '../../../components/Headers/SimpleHeader'
import Form from './Form'

const New: React.FC = () => {
  return (
    <>
      <SimpleHeader name="Nova Meta" parentName="Metas" />
      <Form />
    </>
  )
}

export default New;